'use client';

import type { ClientArgs, ClientInferResponseBody } from '@ts-rest/core';
import type { UseQueryOptions } from '@ts-rest/react-query/v5';

import type { CandidateJobsContract } from '@packages/contracts';

import { JobQueryKeys } from '../query-keys';

type CandidateJobRoute = typeof CandidateJobsContract;
type JobGetRoute = CandidateJobRoute['findById'];
type JobGetResponse = ClientInferResponseBody<JobGetRoute, 200>['result']['job'];
export type JobGetQueryOptions = UseQueryOptions<
	JobGetRoute,
	ClientArgs,
	JobGetResponse
>;

export const createJobGetQueryOptions = (jobId: null | string): JobGetQueryOptions => {
	return {
		enabled:   !!jobId,
		queryData: { params: { jobId: jobId! } },
		queryKey:  JobQueryKeys.detail(jobId),
		retry:     (failureCount: number, error) => {
			if ('statusCode' in error && (error.statusCode === 404 || error.statusCode === 400)) return false;

			return failureCount < 3;
		},
		select: response => response.body.result.job,
	};
};
